// extracted by mini-css-extract-plugin
module.exports = {"buttonCss":"StandardButton_buttonCss__330tF","link":"StandardButton_link__1RbcK","disabled":"StandardButton_disabled__2JwOf"};